import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import I18n from 'I18n';
import { useIsFallbackModeEnabled } from 'find-and-filter-data/views-data/public';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchAndFilterModeIcon = ({
  clickHandler = () => {}
}) => {
  const customViewsFallbackModeEnabled = useIsFallbackModeEnabled();
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !customViewsFallbackModeEnabled,
    headingText: I18n.text('conversations-inbox-ui.custom-views.fallbackMode.searchAndFilterButtonHeader'),
    placement: "right",
    title: I18n.text('conversations-inbox-ui.custom-views.fallbackMode.navLinkText'),
    children: /*#__PURE__*/_jsx(UIIconButton, {
      disabled: customViewsFallbackModeEnabled,
      use: "transparent",
      onClick: clickHandler,
      placement: "right",
      "data-test-id": "enter-search-and-filtering-mode-button",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "search"
      })
    })
  });
};
SearchAndFilterModeIcon.displayName = 'SearchAndFilterModeIcon';
export default SearchAndFilterModeIcon;